import * as React from 'react';

import * as styles from './styles.css';

interface ILabelsLayoutProps {
  children: React.ReactNode;
}

export function LabelsLayout({ children }: ILabelsLayoutProps) {
  return <div className={styles['container']}>{children}</div>;
}
